import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, MapPin } from "lucide-react";
import { SERVICE_AREAS, reveal } from "./constants";

export function ServiceArea() {
  return (
    <section
      id="area"
      className="relative pt-4 pb-8 sm:pt-6 sm:pb-12 bg-[#FFFFFF]"
      data-testid="service-area-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <motion.div {...reveal} className="lg:col-span-5">
            <div className="text-xs font-bold uppercase tracking-[0.22em] text-[#5FBE1F] mb-4">
              Where I work
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-normal text-[#000000] leading-[1.12]">
              Rooted in Glenwood.
              <br />
              <span className="text-[#5FBE1F]">Reaching across SW Iowa.</span>
            </h2>
            <p className="mt-6 text-[#4A4A46] leading-relaxed">
              If your town isn't on the list, shoot me a text anyway — I
              regularly travel for jobs around the area.
            </p>
            <div className="mt-6 flex items-center gap-3 text-[#0A0A0A]">
              <MapPin className="w-5 h-5" />
              <span className="font-semibold">Based in Glenwood, IA</span>
            </div>
          </motion.div>

          <motion.div
            {...reveal}
            className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-3"
          >
            {SERVICE_AREAS.map((town) => (
              <div
                key={town}
                className="flex items-center gap-3 bg-white border border-[#E5E5E5] px-4 py-4 rounded-sm hover:border-[#5FBE1F] transition-colors"
                data-testid={`town-${town.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <CheckCircle2 className="w-4 h-4 text-[#5FBE1F] flex-shrink-0" />
                <span className="font-semibold text-[#000000]">{town}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
